import getSafe from '../../utils/getSafe';
import {
  FETCH_HOME_FEED_SUCCESS,
  FETCH_HOME_FEED_FAILURE,
  FETCH_HOME_FEED_REQUEST,
  FETCH_HOME_SEARCH_RESULTS_SUCCESS,
  FETCH_HOME_SEARCH_RESULTS_FAILURE,
  FETCH_HOME_SEARCH_RESULTS_REQUEST,
  FETCH_HOME_FULFILLMENT_TIMES_REQUEST,
  FETCH_HOME_FULFILLMENT_TIMES_SUCCESS,
  FETCH_HOME_FULFILLMENT_TIMES_FAILURE,
  CLEAR_HOME_SEARCH_RESULTS,
} from '../../actions/types';

const initialState = {
  results: {
    subheader: '',
    data: [],
  },
  fulfillmentMethods: [],
  sort: [],
  filters: [],
  searchResults: [],
  appliedFilters: [],
  meta: {},
  fulfillmentTimes: {},
  loading: false,
  loadingSearch: false,
  error: undefined,
};

const buildFeed = ({ data }, state) => ({
  appliedFilters: getSafe(() => data.results.controlGroups.appliedFilters) || state.appliedFilters,
  fulfillmentMethods:
    getSafe(() => data.results.controlGroups.fulfillmentMethods) || state.fulfillmentMethods,
  sort: getSafe(() => data.results.controlGroups.sort) || state.sort,
  filters: getSafe(() => data.results.controlGroups.filters) || state.filters,
  results: getSafe(() => data.results.layoutGroups[0]) || state.results,
  meta: getSafe(() => data.results.meta) || state.meta,
  fulfillmentTimes: getSafe(() => data.fulfillmentTimes) || state.fulfillmentTimes,
  searchResults: getSafe(() => data.results.controlGroups.queryResults) || state.searchResults,
});

const buildError = (action) => {
  const errors = getSafe(() => action.payload.errors) || [];

  return {
    status: action.status,
    message: action.message || getSafe(() => errors[0].message),
    data: errors,
  };
};

const buildHomeState = (action, prevState) => {
  const { payload } = action;
  const feed =
    getSafe(() => payload.data.results.layoutGroups[0].data) || initialState.results.data;

  // Fallback to the previous state if:
  // - The new response doesn't have a feed
  // - We have a feed in the previous state
  const state = !feed.length && prevState.results.data.length ? prevState : initialState;

  // If there is a feed as part of the error response then build the new data.
  if (feed.length) {
    return {
      ...state,
      ...buildFeed(payload, state),
      error: undefined, // For now ignore any errors if we have a feed, revist this when the HomeAPI error responses are finalised.
    };
  }

  // If there is no feed data in the results, keep the previous state and add the query errors.
  return {
    ...state,
    error: buildError(action),
  };
};

const buildSearchResults = (action) => {
  const searchResults = getSafe(() => action.payload.data.results.controlGroups.queryResults) || [];
  const bannerResults = getSafe(() => action.payload.data.results.layoutGroups[0].data[0].blocks);
  return searchResults.length ? searchResults : bannerResults || initialState.searchResults;
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_HOME_FEED_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_HOME_FEED_SUCCESS:
      return {
        ...buildHomeState(action, state),
        loading: false,
      };
    case FETCH_HOME_FEED_FAILURE:
      return {
        ...buildHomeState(action, state),
        loading: false,
      };
    case FETCH_HOME_SEARCH_RESULTS_REQUEST:
      return {
        ...state,
        loadingSearch: true,
      };
    case FETCH_HOME_SEARCH_RESULTS_SUCCESS:
      return {
        ...state,
        searchResults: buildSearchResults(action),
        loadingSearch: false,
      };
    case FETCH_HOME_SEARCH_RESULTS_FAILURE:
      return {
        ...state,
        loadingSearch: false,
      };
    case FETCH_HOME_FULFILLMENT_TIMES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_HOME_FULFILLMENT_TIMES_SUCCESS:
      return {
        ...state,
        ...buildFeed(action.payload, state),
        error: undefined,
        loading: false,
      };
    case FETCH_HOME_FULFILLMENT_TIMES_FAILURE:
      return {
        ...state,
        error: buildError(action),
        loading: false,
      };
    case CLEAR_HOME_SEARCH_RESULTS:
      return {
        ...state,
        searchResults: [],
      };
    default:
      return state;
  }
}
